import React from 'react';

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";
import {Tab, Tabs} from "@material-ui/core";
import classNames from "classnames";
import UserRoles from "../../../../../constants/UserRoles";

const breadcrumbsStatic = [
	{
		name: 'Customer',
		url: '/customers',
		icon: 'user',
	}
];

export default class Customer extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');

		this.state = {
			...this.state,
			name: '',
		}
	}

	refreshPage = () => {
		this.setState({
			locations: [],
			key: Math.random(),
			refresh: !this.state.refresh
		});
	};

	render() {
		let {match, history, baseUrl, roles} = this.props;
		let {name} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				// TODO, check where state is set in View, then can update this on state state change
				name,
				url: `/customers/${match.params.id}`,
				icon: 'users',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Customer" value="details" data-cy={"customer-tab"}/>
					<Tab label="Membership" value="memberships"/>
					<Tab label="Change Log" value="logs"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'details'})}>
					<Objects.Customer
						key={this.state.key}
						id={match.params.id}
						history={history}
						onData={this.handleData}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						loadLocations={this.loadLocations}
						baseUrl={baseUrl}
						goBack={true}
						noDelete={(roles < UserRoles.Supervisor || roles === undefined)}
						dataIdSave={"customer-save"}
						dataIdDelete={"customer-delete"}
						fromRoute={true}
						roles={this.props.roles}
					/>
				</div>

				<div className={classNames('memberships-page', {'hidden': this.state.tab !== 'memberships'})}>
					<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
						<Collections.Memberships
							customer={match.params.id}
							customerName={name}
							roles={this.props.roles}
							history={history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
						/>
					</Framework.Errors.General>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'logs'})}>
					<Collections.CustomersLogs
						parent={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={false}
					/>
				</div>
			</div>
		)
	}
}
